// This file is generated by Style Dictionary
const tokens = {
  buttons: {
    gap: '16px',
  },
  chipHorizontal: '8px',
  containedInteractionHorizontal: '16px',
  contentToButton: {
    gapDesktopTablet: '32px',
    gapMobile: '24px',
  },
  contents: {
    gapLarge: '64px',
    gapMedium: '32px',
    gapSmall: '16px',
    gapXsmall: '8px',
  },
  form: {
    field: {
      gap: '4px',
      inline: '8px',
    },
    fields: {
      gapDesktop: '32px',
      gapMobile: '24px',
    },
    selection: {
      gap: '8px',
    },
  },
  interactionInline: '8px',
  metaGap: '8px',
  navigationInline: '16px',
  section: {
    padding: {
      horizontal: {
        desktopLg: '64px',
        desktopMd: '32px',
        desktopXl: '200px',
        mobileXs: '16px',
        tabletSm: '32px',
      },
      vertical: {
        desktopTablet: '64px',
        mobile: '48px',
      },
    },
  },
  selectionInline: '16px',
  subheadingToText: {
    gap: '4px',
  },
  surface: {
    paddingLarge: '32px',
    paddingMedium: '24px',
    paddingSmall: '16px',
  },
  table: {
    padding: '16px',
  },
  textButtonHorizontal: '8px',
};
export default tokens;
